import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/ResdesManagementSummaryEpgSelectors';

class ResdesManagementSummaryEpgContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showLegendEpgModal: true,
      // eslint-disable-next-line react/no-unused-state
      showModal: true,
      headerTitle: true,
      epgTitle: `EPG - RESDES SCANNING PERFORMANCE - 13 months ongoing
        EPG Management Summary`,
    };
  }

  closeChart = () => {
    this.setState({
      // eslint-disable-next-line react/no-unused-state
      showModal: false,
    });
  };

  render() {
    const { data } = this.props;
    // const filteredData = data.filter((item, index) => (index !== 0 && index !== 1));
    const totalRows = data.slice(0, 2);
    return (
      <Report
        reportId={ReportDefinitions.RESDES_MANAGEMENT_SUMMARY_EPG.id}
        columns={this.props.columns}
        isLoading={this.props.isLoading}
        generatedOnDateTime={this.props.generatedDateTime}
        data={this.props.data}
        showLegendEpgModal={this.state.showLegendEpgModal}
        headerTitle={this.state.headerTitle}
        pdfButton
        totalRows={totalRows}
        epgTitle={this.state.epgTitle}
        closeChart={this.closeChart}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

ResdesManagementSummaryEpgContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(ResdesManagementSummaryEpgContainer);
